import styles from '../Styles/Hero.module.css';
import Container from '../UI/Container';
import Button from '../UI/Button';

const Hero = () => {
  const handleWhatsApp = () => {
    const phone = '3125575616';
    const message = encodeURIComponent(
      'Hola, me gustaría recibir más información sobre sus servicios.'
    );
    window.open(`https://wa.me/${phone}?text=${message}`, '_blank');
  };

  return (
    <section id="inicio" className={styles.hero}>

      {/* ── Decorativos de fondo ── */}
      <div className={`${styles.orb} ${styles.orb1}`} />
      <div className={`${styles.orb} ${styles.orb2}`} />
      <div className={`${styles.orb} ${styles.orb3}`} />
      <div className={styles.scanLine} />

      {/* Circuito esquina superior izquierda */}
      <svg
        className={`${styles.cornerCircuit} ${styles.cornerTl}`}
        width="180" height="180" viewBox="0 0 180 180" fill="none"
        aria-hidden="true"
      >
        <path d="M0 40 H30 V10 H80"          stroke="#00AACD" strokeWidth="1.5" />
        <path d="M0 80 H60 V50 H120"          stroke="#00AACD" strokeWidth="1" />
        <path d="M0 120 H20 V90 H70 V60 H140" stroke="#31216F" strokeWidth="1" />
        <circle cx="80"  cy="10" r="3" fill="#00AACD" />
        <circle cx="120" cy="50" r="2" fill="#00AACD" opacity="0.6" />
        <circle cx="140" cy="60" r="3" fill="#31216F" />
        <rect x="26" y="6" width="8" height="8" fill="none" stroke="#00AACD" strokeWidth="1" />
      </svg>

      {/* Circuito esquina inferior derecha */}
      <svg
        className={`${styles.cornerCircuit} ${styles.cornerBr}`}
        width="180" height="180" viewBox="0 0 180 180" fill="none"
        aria-hidden="true"
      >
        <path d="M0 40 H30 V10 H80"          stroke="#00AACD" strokeWidth="1.5" />
        <path d="M0 80 H60 V50 H120"          stroke="#00AACD" strokeWidth="1" />
        <path d="M0 120 H20 V90 H70 V60 H140" stroke="#31216F" strokeWidth="1" />
        <circle cx="80"  cy="10" r="3" fill="#00AACD" />
        <circle cx="120" cy="50" r="2" fill="#00AACD" opacity="0.6" />
        <circle cx="140" cy="60" r="3" fill="#31216F" />
      </svg>

      {/* ── Contenido ── */}
      <Container>
        <div className={styles.content}>

          {/* Badge / slogan */}
          <div className={styles.sloganBadge}>
            Su aliado tecnológico estratégico
          </div>

          {/* Título */}
          <h1 className={styles.title}>
            Tu Infraestructura,<br />
            <span className={styles.titleHighlight}>Protegida y Conectada</span>
            <span className={styles.titleUnderline} />
          </h1>

          {/* Descripción */}
          <p className={styles.description}>
            En <strong>FacSystem Col</strong> transformamos la tecnología en una
            ventaja real para tu negocio. Seguridad CCTV, redes, mantenimiento
            y electricidad — soluciones integrales que mantienen tu operación{' '}
            <strong>activa las 24 horas</strong>.
          </p>

          {/* Stats */}
          <div className={styles.stats}>
            <div className={styles.statItem}>
              <span className={styles.statNumber}>CCTV</span>
              <span className={styles.statLabel}>Vigilancia 24/7</span>
            </div>
            <div className={styles.statDivider} />
            <div className={styles.statItem}>
              <span className={styles.statNumber}>LAN</span>
              <span className={styles.statLabel}>Redes estructuradas</span>
            </div>
            <div className={styles.statDivider} />
            <div className={styles.statItem}>
              <span className={styles.statNumber}>TEC</span>
              <span className={styles.statLabel}>Soporte especializado</span>
            </div>
          </div>

          {/* CTA — wrapper con anillos de radar */}
          <div className={styles.btnWrap}>
            <Button variant="whatsapp" onClick={handleWhatsApp}>
              Cotizar por WhatsApp
            </Button>
          </div>

        </div>
      </Container>
    </section>
  );
};

export default Hero;